// Decode JWT token to get user information
export const decodeToken = (token) => {
  if (!token) return null;
  
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    const decoded = JSON.parse(jsonPayload);
    console.log('Decoded token:', decoded);
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

// Get user ID from stored token
export const getUserIdFromToken = () => {
  const token = localStorage.getItem('authToken');
  console.log('Raw token from localStorage:', token ? 'Token exists' : 'No token');
  
  if (!token) {
    console.error('No auth token found in localStorage');
    return null;
  }
  
  const decoded = decodeToken(token);
  console.log('Getting userId from token. Decoded:', decoded);
  console.log('userId:', decoded?.userId);
  return decoded?.userId || null;
};

// Get full user info from token
export const getUserFromToken = () => {
  const token = localStorage.getItem('authToken');
  return decodeToken(token);
};

// Alternative: Get user ID from stored user object (fallback)
export const getUserIdFromStorage = () => {
  console.log('Attempting to get userId from localStorage user object...');
  try {
    const userStr = localStorage.getItem('user');
    console.log('User string from localStorage:', userStr);
    
    if (userStr) {
      const user = JSON.parse(userStr);
      console.log('Parsed user object:', user);
      console.log('User ID from storage:', user.id);
      return user.id;
    } else {
      console.log('No user object in localStorage');
    }
  } catch (error) {
    console.error('Error getting user from storage:', error);
  }
  
  console.log('Falling back to getUserIdFromToken...');
  return getUserIdFromToken();
};
